<div class="mb-40 title-with-icon">
  <div *ngIf="showArrow" (click)="back()" class="circle-icon clickable" [ngClass]="{'disabled': disabled}">
    <i class="fa fa-chevron-left"></i>
  </div>
  <div><h2 class="page-title-text">{{text | translate}}</h2></div>
  <div *ngIf="!showArrow" (click)="back()" class="circle-icon clickable" [ngClass]="{'disabled': disabled}">
    <i class="fa fa-times"></i>
  </div>
</div>
